import {Case} from './Case';
import {User} from './User';
import {FrxBaseBean} from './frxbasebean';
export class TaskFrx extends FrxBaseBean {
	otgovornik: User;
	opisanie: string;
	deadline: Date;
	deadlineString: string;
	statusTask: string;
	statusTaskBG: string;
	isNakazatelno: Boolean = false;
	lawsuiteId: Number;
  isWarning: Boolean = false;
  color: any;

	constructor() {
		super();
	}

	copy(source: TaskFrx) {
		super.copy(source);
		this.otgovornik = source.otgovornik;
		this.opisanie = source.opisanie;
		this.deadline = source.deadline;
		this.statusTask = source.statusTask;
		this.isNakazatelno = source.isNakazatelno;
		this.lawsuiteId = source.lawsuiteId;
    this.isWarning = source.isWarning;
    this.color = source.color;
	}
}
